export default "__VITE_ASSET__ZC$NPQdf__"